// Canadian/US numbers only for now: the shop calls and texts locally.

// "(647) 555-0147", "647-555-0147", "16475550147" -> "+16475550147", or null if invalid.
export const toE164 = (input) => {
  const digits = (input || "").replace(/\D/g, "");
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return null;
};

// "+16475550147" -> "(647) 555-0147". Leaves anything unexpected as-is.
export const formatPhone = (e164) => {
  const match = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164 || "");
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : e164 || "";
};

// Formats as the user types: "6475" -> "(647) 5".
export const formatPhoneInput = (input) => {
  let digits = (input || "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const CONTACT_PREFS = [
  { value: "call", label: "Call" },
  { value: "text", label: "Text" },
  { value: "email", label: "Email" },
];
